import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=228cbde0&scoped=true"
import script from "./CarForm.vue?vue&type=script&lang=ts"
export * from "./CarForm.vue?vue&type=script&lang=ts"
import style0 from "./CarForm.vue?vue&type=style&index=0&id=228cbde0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228cbde0",
  null
  
)

export default component.exports